import { takeLatest, call, put, select } from 'redux-saga/effects';

// Services
import { walletApi } from 'services/apiDigitalTicket/wallet';

// Actions
import * as DialogsActions from 'store/ducks/dialogs/actions';
import * as SnackbarsActions from 'store/ducks/snackbars/actions';

// Constants
import { errorMessagersList } from 'helpers/errorMessagers';

import * as walletHistoryActions from './actions';
import { WalletHistoryTypes } from './types';

function* getWalletHistory({
  payload,
}: ReturnType<typeof walletHistoryActions.getWalletHistoryRequest>): any {
  try {
    yield put(
      DialogsActions.setOpenLoading({
        title: 'Carregando listagem de compras do usuário',
      }),
    );

    const transportOperator = yield select(
      (state) => state.transportOperators.transportOperatorSelected,
    );

    const response = yield call(walletApi.walletHistory, {
      params: { transportOperatorId: transportOperator.id, ...payload },
    });

    if (response.status === 200) {
      yield put(
        walletHistoryActions.getWalletHistorySuccess({
          walletHistoryList: response.data,
          totalCount: parseInt(response.headers.totalCount, 10),
        }),
      );

      yield put(DialogsActions.setClose());
    }
  } catch (error) {
    const internalCode: string =
      error.response && error.response.data.internalCode;
    const message = errorMessagersList(internalCode);

    console.error('Wallet - History - error', error);
    yield put(
      SnackbarsActions.setOpen({
        open: true,
        type: 'error',
        message,
      }),
    );
    yield put(walletHistoryActions.getWalletHistoryFailure());
    yield put(DialogsActions.setClose());
  }
}

// eslint-disable-next-line import/prefer-default-export
export const walletSagas = [
  takeLatest(WalletHistoryTypes.GET_HISTORY_REQUEST, getWalletHistory),
];
